// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseRoadNetworkAreaRoutes = {
  route: '/road-network',
}

export const RoadNetworkAreaRoutes = transformRoutes(BaseRoadNetworkAreaRoutes)
